import React from 'react';
import { Navigate } from 'react-router-dom';
import { isLimitedAdmin } from '../services/auth';

// Wrap admin routes a Limited Admin must not reach (financial/payment/users).
// The backend still denies the data; this keeps the UI from showing a broken page.
export default function FullAdminRoute({ children }) {
  if (isLimitedAdmin()) return <Navigate to="/admin/dashboard" replace />;
  return children;
}
